<template>
  <div id="Contract" class="fit q-px-md">
    <q-form
      @submit.prevent="onSubmit"
      @reset="onReset"
      class="q-gutter-md row form-container"
    >
      <div class="col-2 ">
        <label for="replaceProduct"><strong><translate>REPLACE_PRODUCT</translate>:</strong></label>
        <q-radio
          v-model="maySelectAProduct"
          :val="true"
          :label="$gettext('YES_CAPITALIZE')"
          name="replaceProduct"
          class="radio-button"
        />
        <q-radio
          v-model="maySelectAProduct"
          :val="false"
          :label="$gettext('NO_CAPITALIZE')"
          name="replaceProduct"
          class="radio-button"
        />
      </div>
      <div v-if="maySelectAProduct" class="col-3 select-box">
        <label><strong><translate>REPLACE_FOR</translate>:</strong></label>
        <div>{{ serviceTypeDescription }}</div>
      </div>
      <q-btn
        :label="$gettext('CHANGE')"
        :disable="shouldDisableUpdateButton"
        type="submit"
        color="primary"
        class="submit-button"
      />
    </q-form>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'src/jtech/jtech-repository'
import { messageBox } from 'src/jtech'

@Component({
  name: 'ChangeProductForm',
  components: {
  },
  props: {
    contractServiceId: Number,
    replaceProduct: Boolean,
    serviceTypeId: Number,
    serviceTypeDescription: String
  }
})
class ChangeProductForm extends Vue {
  maySelectAProduct = false

  async onSubmit () {
    await repository.resolveLogic('contractService.updateReplaceProduct', {
      id: this.contractServiceId,
      replaceProduct: this.maySelectAProduct
    })
    messageBox.success(this.$gettext('UPDATED_WITH_SUCCESS'), 'top-right')
  }

  setMaySelectAProductModel () {
    this.maySelectAProduct = this.replaceProduct
  }

  mounted () {
    this.setMaySelectAProductModel()
  }

  get shouldDisableUpdateButton () {
    return this.maySelectAProduct === this.replaceProduct
  }
}
export default ChangeProductForm
</script>
<style scoped>
.form-container {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 10px;
  gap: 16px;
}

.radio-button {
  margin-left: 0;
  margin-top: 0;
}

.select-box {
  margin: 0;
  padding: 0;
}

.submit-button {
  margin-left: 24px;
  margin-top: 0;
}
</style>
